import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "es"],
    fallbackLng: "en",

    debug: true,

    resources: {
      en: {
        translation: {
          changeLanguage: "Change Language",
        },
      },

      es: {
        translation: {
          changeLanguage: "Cambiar idioma",
        },
      },
    },

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
  });

export default i18n;